var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcodeInstallerAppUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "full",
    width: "2.7778in",
    height: "2.7778in",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsEv: "http://www.w3.org/2001/xml-events",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    id: "qrcode-finders",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("g", {
    className: "finder",
    id: "finder-top-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4,4 l7,0 0,7 -7,0 z m1,1 l5,0 l0,5 l-5,0 z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "finder-center",
    x: 6,
    y: 6,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    className: "finder",
    id: "finder-bottom-left"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4,22 l7,0 0,7 -7,0 z m1,1 l5,0 l0,5 l-5,0 z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "finder-center",
    x: 6,
    y: 24,
    width: 3,
    height: 3
  })), /*#__PURE__*/React.createElement("g", {
    className: "finder",
    id: "finder-top-right"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22,4 l7,0 0,7 -7,0 z m1,1 l5,0 l0,5 l-5,0 z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "finder-center",
    x: 24,
    y: 6,
    width: 3,
    height: 3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    id: "qrcode-data",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 6,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 4,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 6,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 11,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 5,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 7,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 23,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 28,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 13,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 17,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 20,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 21,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 12,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 14,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 15,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 16,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 18,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 24,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 25,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 26,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 27,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 1,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeInstallerAppUk);
export default __webpack_public_path__ + "static/media/qrcode.Installer-app-UK.e573c7d228a07372a42f9b04a8372a6a.svg";
export { ForwardRef as ReactComponent };